import workastDataConstants from './constants';

const workastDataActions = {
  /**
 * Sets Workast information (user name, organization, token) about the user in the redux store.
 * We use this to display the user and company name in the integration, as well as to authenticate
 * the user when interacting with the API.
 * @param {Object} data - Workast data.
 * @param {String} data.listId - Id of the list this form belongs to.
 * @param {String} data.token - Workast token to identify the user
 * when interacting with the API.
 * @param {Object} data.user - User information, same as retrieved with /user/me endpoint.
 */
  setInitialData: data => ({
    type: workastDataConstants.SET_INITIAL_DATA,
    payload: {
      data
    }
  })
};

export default workastDataActions;
